/** @format */

import { AuthState } from "./interface";

export const initialState: AuthState = {
  signedIn: false,
  token: null,
  refresh_token: null,
};
